<div class="mapfre-login-header" [ngClass]="{'mapfre-login-header--scroll-mode': scrollMode}">
  <div class="mapfre-login-header__content">
    <ion-menu-button mode="md"></ion-menu-button>
    <div
      class="mapfre-login-header__logo margin-logo"
    >
      <img src="assets/images/mapfre-logo.svg" alt="Logo Mapfre" (click)="goToPortalHome()"/>
    </div>

    <div class="caret"
      *ngIf="!scrollMode"
      [style.left.px]="caretLeft"
      [style.width.px]="caretWidth"
      [ngClass]="{'caret--animated': caretAnimated}"
    ></div>

    <ion-buttons class="tab-buttons mapfre-hide-tablet mapfre-hide-mobile">
      <div class="tab-buttons__start">
        <ion-button
          *ngIf="!scrollMode"
          [ngClass]="{ selected: tabHovered === headerTabs.particular.url || baseTabUrl === headerTabs.particular.url }"
          mode="md"
          color="medium"
          (click)="nav.toNew(headerTabs.particular.url)"
          (mouseenter)="onEnterTab($event.srcElement, headerTabs.particular.url)"
          (mouseleave)="onLeaveTab()"
          #particularTab
        >
          <ion-label>{{ headerTabs.particular.title | translate }}</ion-label>
        </ion-button>

        <ion-button
          [ngClass]="{ selected: tabHovered === headerTabs.business.url || baseTabUrl === headerTabs.business.url }"
          mode="md"
          color="medium"
          (click)="nav.toNew(headerTabs.business.url)"
          (mouseenter)="onEnterTab($event.srcElement, headerTabs.business.url)"
          (mouseleave)="onLeaveTab()"
          #businessTab
        >
          <ion-label>{{ headerTabs.business.title | translate }}</ion-label>
        </ion-button>
      </div>

      <ion-button
        *ngIf="!scrollMode"
        [ngClass]="{ selected: tabHovered === headerTabs.contact.url || baseTabUrl === headerTabs.contact.url }"
        mode="md"
        color="medium"
        (click)="nav.toNew(headerTabs.contact.url)"
        (mouseenter)="onEnterTab($event.srcElement, headerTabs.contact.url)"
        (mouseleave)="onLeaveTab()"
        #contactsTab
      >
        <ion-label>{{ headerTabs.contact.title | translate }}</ion-label>
      </ion-button>

      <ion-button
        *ngIf="!scrollMode && showFaq"
        [ngClass]="{ selected: tabHovered === headerTabs.faq.url || baseTabUrl === headerTabs.faq.url }"
        mode="md"
        color="medium"
        (click)="nav.toNew(headerTabs.faq.url)"
        (mouseenter)="onEnterTab($event.srcElement, headerTabs.faq.url)"
        (mouseleave)="onLeaveTab()"
        #faqTab
      >
        <ion-label>{{ headerTabs.faq.title | translate }}</ion-label>
      </ion-button>
    </ion-buttons>
    <div *ngIf="scrollMode" class="scroll-button">
      <ion-button
        color="primary"
        mode="md"
        (click)="onClickScroll()"
      >
        <ion-label>{{ 'LOGIN.SIGN_IN_BUSINESS' | translate }}</ion-label>
      </ion-button>
    </div>
  </div>
</div>
